export default {
	setUser (state, payload){
			state.user = {...payload}
	},
	setUid (state,payload){
			state.uid = payload
	},
	setToken(state, payload){
			state.token = payload
	},
	setOnline (state, payload) {
			state.online = payload
	},
	setDevInfo (state, payload) {
			state.devInfo = {...state.devInfo, ...payload}
	},
	setOFFSET (state, payload) {
			state.OFFSET = payload
	},
	setInviteCode(state, payload){
			state.inviteCode = payload
	},
	setNewMessage (state, payload) {
			state.newMessage = payload
	},
	addMessage (state, payload) {
			state.messages = [payload].concat(state.messages);
	},
	addMessages (state, payload) {
			const messages = [...state.messages];

			// ios下数据有重复，去重处理
			payload.forEach((message) => {
					if (!state.messages.some(msg => msg.id === message.id)) {
							messages.push(message);
					}
			});

			state.messages = messages;
	},
	setNeteasecloud (state, payload) {
			state.neteasecloud = payload
	},	
	setDrawGameId (state,payload){
		state.drawGameId = payload
	},
	setDrawInviteCode (state,payload){
		state.drawInviteCode = payload
	},
	setIsCanDrawFlag (state,payload){
		state.isCanDrawFlag = payload
	}
}